const listeners = new Set();

function publish(notification) {
  listeners.forEach((listener) => listener(notification));
}

/**
 * Punto de entrada global para avisos breves protagonizados por SINA.
 * La promesa se resuelve cuando el usuario cierra el aviso o termina su duración.
 */
export const sina = Object.freeze({
  notify(options = {}) {
    return new Promise((resolve) => {
      publish({
        id: `${Date.now()}-${Math.random().toString(36).slice(2)}`,
        type: ['success', 'warning', 'error', 'info'].includes(options.type) ? options.type : 'info',
        title: options.title || 'SINA te avisa',
        message: options.message || '',
        actionText: options.actionText,
        primaryAction: options.primaryAction,
        secondaryAction: options.secondaryAction,
        blocking: Boolean(options.blocking),
        avatarState: options.avatarState,
        eyebrow: options.eyebrow,
        typewriter: Boolean(options.typewriter),
        duration: options.duration,
        resolve,
      });
    });
  },
});

export function subscribeToSinaNotifications(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export default sina;
